import React from 'react';
import { Tag } from 'lucide-react';
import ContentGenerationService from '../common/ContentGenerationService';

const KeywordService = ({
  keywordYoutubeUrl,
  setKeywordYoutubeUrl,
  youtubeVideoInfo,
  extractingVideoInfo,
  setYoutubeVideoInfo,
  generatedKeywords,
  currentKeywordProjectId,
  isProcessing,
  handleKeywordProcessing,
  handleViewKeywordProject,
  user = null,
}) => {
  return (
    <ContentGenerationService
      config={{
        featureType: 'keyword',
        featureName: 'Keyword Generation',
        icon: Tag,
        color: 'design',
        youtubeUrl: keywordYoutubeUrl,
        setYoutubeUrl: setKeywordYoutubeUrl,
        youtubeVideoInfo,
        setYoutubeVideoInfo,
        extractingVideoInfo,
        generatedContent: generatedKeywords,
        currentProjectId: currentKeywordProjectId,
        isProcessing,
        handleProcessing: handleKeywordProcessing,
        handleViewProject: handleViewKeywordProject,
        setShowSettingsModal: () => {},
        user,
        // Prompt-related props removed for keywords
        fetchPrompt: () => {},
        prompt: '',
        promptVersion: 1,
        promptTotalVersions: 1,
        selectedPromptVersionForUse: null,
        isEditingPrompt: false,
        editedPrompt: '',
        promptLoading: false,
        setIsEditingPrompt: () => {},
        setEditedPrompt: () => {},
        handlePromptVersionChange: () => {},
        savePrompt: async () => {},
        setSelectedPromptVersionForUse: () => {},
        fetchPromptVersion: async () => {},
        selectedPromptId: null,
        projectTypes: [
          { value: 'keyword_generation', label: 'Keyword Generation', icon: Tag }
        ],
        defaultProjectType: 'keyword_generation',
        showComparisonOption: false,
        defaultHasVideoAsset: true, // Default to MP4 upload for keywords
      }}
    />
  );
};

export default KeywordService;
